

export const derivePhone=(countryCode, phoneNumber)=>
   (!countryCode || countryCode=='65') ? phoneNumber : '+'+countryCode+' '+phoneNumber


export const generatePhoneDetail=(v)=>
{
    if (v && v.phone)
    {
        let p = v.phone.trim()
        if (p.startsWith('+'))
        {
            let c = p.substring(1).split(" ");
            
            if (c && c.length>1)
            {
                v.countryCode = c[0];
                v.phoneNumber=c[1];
            }
            else
            {
                v.phoneNumber=v.countryCode=''
            }
        }
        else
        {
            v.phoneNumber=p
            v.countryCode='65'
        }

        v.phoneDisplay = (v.countryCode&&v.phoneNumber) ? '+'+v.countryCode+'-'+v.phoneNumber :""
    }
    else
    {
        v.countryCode='65'
        v.phoneNumber=''
        v.phoneDisplay=''
    }
}
   
